/**
 * Adds functionality to the file upload control
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/traversal/parents/parents.js";
import "dabbyjs/src/traversal/children/children.js";
import "dabbyjs/src/manipulation/text/text.js";
import "dabbyjs/src/utils/each/each.js";

export default (obj, name) => {
	obj.on("change", function () {
		const $this = $(this),
			val = [];

		// compile filenames
		if (this.files) {
			$.each(this.files, (i, file) => {
				val.push(file.name);
			});
		} else {
			val.push($this.val());
		}

		// remove filepaths
		val.map(item => {
			const index = item.lastIndexOf("\\");
			if (index > -1) {
				item = item.slice(index + 1);
			}
			return item;
		});

		// set text area
		$this.parent().children(name).text(val.join(", "));
	});
};
